// extracted by mini-css-extract-plugin
export var contentHeading = "style-module--contentHeading--aY7o2";
export var contents = "style-module--contents--JeOBs";
export var floorMap = "style-module--floorMap--3vmwF";
export var heading = "style-module--heading--W85rV";
export var sliderWrapper = "style-module--sliderWrapper--MGKC1";
export var spec = "style-module--spec--cVu7M";
export var specHeading = "style-module--specHeading--Lme94";
export var specImage = "style-module--specImage--UAESi";
export var specItems = "style-module--specItems--btyB9";
export var specText = "style-module--specText--8BeOg";
export var tab = "style-module--tab--V5z8K";
export var tabs = "style-module--tabs--NsOSV";